import React from "react";

import { Link } from 'react-router-dom';
import { Card,   } from "reactstrap";

import {Badge} from 'components/Badges/Badge'

var Utils = require ('Utils');
var Const = require ('Const');


export const  PersonasBadge = ( { persona, course, tags, uploadImage } ) => { 
    return (
        <>
        {persona && 
            <Card className="card-user">
                <div className="image">
                  <img
                    alt="..."
                    src={require("img/student-badge-back.jpg")}
                  />
                </div>
                <div className="author">
                
                 <img
                    alt="..."
                    className="avatar border-gray"
                    src={persona.image?persona.image:Const.DEFAULT_IMAGE_PROFILE[(persona.gender?persona.gender:'O')]}
                    />
                    <a href="#1" onClick={() => uploadImage(true)} >
                          <div style={{
                              position: 'absolute', 
                              top: '71%', 
                              left: '50%', 
                              borderRadius: '4px', 
                              padding: '3px 7px', 
                              transform: 'translate(-50%, -50%)',
                              color: 'rgb(255 255 255)',
                              backgroundColor: 'rgb(255 98 98)',
                              
                          }}>
                            Cambiar
                          </div> 
                      </a>
                    <h5 className="title text-success">{Utils.capitalize(persona.last_name + ", " + persona.name)}</h5>

                {course && 
                  <h5>Curso: <Link to={"/admin/course/" + course.course_id}> {course.name} </Link > </h5>
                //   :
                // <p>No inscripto en este periodo lectivo</p>
                // 
              }
                { tags && tags.map( tag => {
                     return ( 
                        <Badge 
                          bgcolor={tag.tag_color} 
                          cancel={()=>{alert('No Implementado')}}
                          >{tag.tag_label}</Badge>
                     )
                    }) }
                </div>
                
              </Card>
            }
        </>
    );
  }


